'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Welcome = function Welcome(element) {
    _classCallCheck(this, Welcome);

    var fragment = document.createDocumentFragment();
    new _NavigationBarControl2.default(fragment, {
        title: 'Welkom'
    });

    var div = document.createElement('div');
    div.className = 'viewport';

    var p = document.createElement('p');
    p.innerHTML = 'Hartelijk dank voor het gebruik van PRIM. Wij zullen in de volgende stappen u een aantal beveiligingsvragen stellen. Hierna kunt u beginnen met werken.';

    var button = document.createElement('button');
    button.innerHTML = 'Volgende';
    button.onclick = function () {
        window.PRIM.navigate('/entercredentials/');
    };

    div.appendChild(p);
    div.appendChild(button);
    fragment.appendChild(div);

    element.appendChild(fragment);
};

exports.default = Welcome;


//////////////////
// WEBPACK FOOTER
// ./js/modules/start/action/Welcome.js
// module id = 77
// module chunks = 0